import { CASES } from "./constants";

/**
 * Updates TAP job-related state in the Redux store.
 * @param {Object} payload - State properties to merge into the tapJobs slice
 */
export const updateJobs = (payload) => {
  return { type: CASES.UPDATE_JOBS, payload };
};

/**
 * Updates a specific field in the TAP jobs search form.
 * @param {Object} params
 * @param {string} params.key - The form state key to update (e.g., 'filterForm')
 * @param {Object} params.data - The field data to merge into the form
 */
export const updateJobsSearchForm = ({ key, data }) => {
  return {
    type: CASES.UPDATE_JOBS_SEARCH_FORM,
    payload: { key, data },
  };
};

/**
 * Resets the TAP jobs state to initial values, preserving dropdown options and sort preference.
 */
export const clearJobs = () => {
  return { type: CASES.CLEAR_JOBS, payload: {} };
};

/**
 * Resets the job view modal state including tasks and selected job.
 */
export const clearJobViewModal = () => {
  return { type: CASES.CLEAR_JOB_VIEW_MODAL, payload: {} };
};

/**
 * Resets the job tasks modal state and clears selected job.
 */
export const clearJobTasksModal = () => {
  return { type: CASES.CLEAR_JOB_TASKS_MODAL, payload: {} };
};
